import {
  ExecutiveSummaryPeriodType,
  ExecutiveSummaryStatus,
  ExecutiveSummaryTransactionItemType,
  HeaderOptionName,
  MerchantType,
} from "@/enums/enums";
import { ColumnModel, CredentialModel, ElementDefaultModel } from "./documentModel";
import { SettingExecutiveSummaryDocumentTemplateModel } from "./settingDocumentTemplate";

export class ExecutiveSummaryOnlineViewModel {
  document!: ExecutiveSummaryDocumentDetailModel;
  template!: SettingExecutiveSummaryDocumentTemplateModel;
  merchantId!: number;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  credential!: CredentialModel;
  headerOptionType!: number;
}

export class ExecutiveSummaryDocumentDetailModel {
  data!: ExecutiveSummaryDocumentModel;
  version!: number;
}

export class ExecutiveSummaryDocumentModel {
  merchant!: DocumentMerchantExecutiveSummaryModel;
  user!: DocumentUserExecutiveSummaryModel;
  executiveSummary!: DocumentExecutiveSummaryModel;
}

export class DocumentMerchantExecutiveSummaryModel {
  merchantId!: number;
  logoUrl!: string;
  name!: string;
  merchantType!: MerchantType;
  taxNumber!: string;
  branchCode!: string;
}

export class DocumentUserExecutiveSummaryModel {
  userId!: number;
  name!: string;
}

export class DocumentExecutiveSummaryModel {
  isDeleted!: boolean;
  id!: number;
  createdDateTime!: Date;
  status!: ExecutiveSummaryStatus;
  name!: string;
  number!: string;
  fromDate!: Date;
  toDate!: Date;
  setting!: DocumentExecutiveSummarySettingModel;
  transaction!: DocumentExecutiveSummaryTransactionModel;
}

export class DocumentExecutiveSummarySettingModel {
  operationIncomeHidden!: boolean;
  costsOfSalesHidden!: boolean;
  grossProfitHidden!: boolean;
  expensesHidden!: boolean;
  costOfFinancingHidden!: boolean;
  taxRevenuesHidden!: boolean;
  netProfitHidden!: boolean;
  cashReceivedHidden!: boolean;
  cashSpentHidden!: boolean;
  gainsInForeignExchangeHidden!: boolean;
  netCashReceivedHidden!: boolean;
  cashBalanceHidden!: boolean;
  accountsReceivableHidden!: boolean;
  inventoryHidden!: boolean;
  accountsPayableHidden!: boolean;
  quickRatioHidden!: boolean;
  inventoryTurnOverHidden!: boolean;
  receivablesTurnOverHidden!: boolean;
  accountPayableTurnOverRatioHidden!: boolean;
  averagePaymentPeriodHidden!: boolean;
  averageInventoryPeriodHidden!: boolean;
  averageCollectionPeriodHidden!: boolean;
  cashConversionCycleHidden!: boolean;
  quotationNumberIssuedHidden!: boolean;
  quotationNetAmountIssuedHidden!: boolean;
  quotationAverageIssuedHidden!: boolean;
  invoiceNumberIssuedHidden!: boolean;
  invoiceNetAmountIssuedHidden!: boolean;
  invoiceAverageIssuedHidden!: boolean;
  roeHidden!: boolean;
  netProfitMarginHidden!: boolean;
  totalAssetTurnOverHidden!: boolean;
  equityMultiplierHidden!: boolean;
  roaHidden!: boolean;
  totalEquityTurnOverHidden!: boolean;
  grossProfitRatioHidden!: boolean;
}

export class DocumentExecutiveSummaryTransactionModel {
  periodList!: Array<DocumentExecutiveSummaryPeriodModel>;
  periodType!: ExecutiveSummaryPeriodType;
  operationIncome!: DocumentExecutiveSummaryTransactionItemModel;
  costsOfSales!: DocumentExecutiveSummaryTransactionItemModel;
  grossProfit!: DocumentExecutiveSummaryTransactionItemModel;
  expenses!: DocumentExecutiveSummaryTransactionItemModel;
  costOfFinancing!: DocumentExecutiveSummaryTransactionItemModel;
  taxRevenues!: DocumentExecutiveSummaryTransactionItemModel;
  netProfit!: DocumentExecutiveSummaryTransactionItemModel;
  cashReceived!: DocumentExecutiveSummaryTransactionItemModel;
  cashSpent!: DocumentExecutiveSummaryTransactionItemModel;
  gainsInForeignExchange!: DocumentExecutiveSummaryTransactionItemModel;
  netCashReceived!: DocumentExecutiveSummaryTransactionItemModel;
  cashBalance!: DocumentExecutiveSummaryTransactionItemModel;
  accountsReceivable!: DocumentExecutiveSummaryTransactionItemModel;
  inventory!: DocumentExecutiveSummaryTransactionItemModel;
  accountsPayable!: DocumentExecutiveSummaryTransactionItemModel;
  quickRatio!: DocumentExecutiveSummaryTransactionItemModel;
  inventoryTurnOver!: DocumentExecutiveSummaryTransactionItemModel;
  receivablesTurnOver!: DocumentExecutiveSummaryTransactionItemModel;
  accountPayableTurnOverRatio!: DocumentExecutiveSummaryTransactionItemModel;
  averagePaymentPeriod!: DocumentExecutiveSummaryTransactionItemModel;
  averageInventoryPeriod!: DocumentExecutiveSummaryTransactionItemModel;
  averageCollectionPeriod!: DocumentExecutiveSummaryTransactionItemModel;
  cashConversionCycle!: DocumentExecutiveSummaryTransactionItemModel;
  quotationNumberIssued!: DocumentExecutiveSummaryTransactionItemModel;
  quotationNetAmountIssued!: DocumentExecutiveSummaryTransactionItemModel;
  quotationAverageIssued!: DocumentExecutiveSummaryTransactionItemModel;
  invoiceNumberIssued!: DocumentExecutiveSummaryTransactionItemModel;
  invoiceNetAmountIssued!: DocumentExecutiveSummaryTransactionItemModel;
  invoiceAverageIssued!: DocumentExecutiveSummaryTransactionItemModel;
  roe!: DocumentExecutiveSummaryTransactionItemModel;
  netProfitMargin!: DocumentExecutiveSummaryTransactionItemModel;
  totalAssetTurnOver!: DocumentExecutiveSummaryTransactionItemModel;
  equityMultiplier!: DocumentExecutiveSummaryTransactionItemModel;
  roa!: DocumentExecutiveSummaryTransactionItemModel;
  totalEquityTurnOver!: DocumentExecutiveSummaryTransactionItemModel;
  grossProfitRatio!: DocumentExecutiveSummaryTransactionItemModel;
}

export class DocumentExecutiveSummaryPeriodModel {
  fromDate!: Date;
  toDate!: Date;
}

export class DocumentExecutiveSummaryTransactionItemModel {
  remark!: DocumentExecutiveSummaryRemarkModel;
  type!: ExecutiveSummaryTransactionItemType;
  accountList!: Array<DocumentExecutiveSummaryAccountModel>;
  summaryList!: Array<DocumentExecutiveSummaryValueModel>;
}

export class DocumentExecutiveSummaryRemarkModel {
  no!: number;
  description!: string;
  header!: string;
}

export class DocumentExecutiveSummaryAccountModel {
  accountId!: number;
  valueList!: Array<DocumentExecutiveSummaryValueModel>;
}

export class DocumentExecutiveSummaryValueModel {
  value!: number;
  changePercent!: number;
}

export class ExecutiveSummaryDocumentTemplateModel {
  transactionType!: number;
  headerOptionType!: number;
  header!: HeaderExecutiveSummaryDocumentModel;
  executiveSummary!: ElementExecutiveSummaryModel;
  remarkList!: Array<ElementExecutiveSummaryRemarkModel>;

  constructor() {
    this.header = new HeaderExecutiveSummaryDocumentModel();
    this.executiveSummary = new ElementExecutiveSummaryModel();
    this.remarkList = new Array<ElementExecutiveSummaryRemarkModel>();
  }
}

export class HeaderExecutiveSummaryDocumentModel {
  originalAmount!: number;
  merchantLogo!: ElementDefaultModel;
  documentName!: ElementDocumentNameExecutiveSummaryModel;
  periodDate!: ElementDefaultModel;
  createUser!: ElementDefaultModel;
  createDate!: ElementDefaultModel;
}

export class ElementDocumentNameExecutiveSummaryModel extends ElementDefaultModel {
  headerOptionName!: HeaderOptionName;
}

export class ElementExecutiveSummaryModel {
  isDeleted!: boolean;
  periodList!: Array<DocumentExecutiveSummaryPeriodModel>;
  periodType!: ExecutiveSummaryPeriodType;
  businessPerformance!: ElementExecutiveSummaryTransactionGroupModel;
  cash!: ElementExecutiveSummaryTransactionGroupModel;
  workingCapital!: ElementExecutiveSummaryTransactionGroupModel;
  quatationAndInvoice!: ElementExecutiveSummaryTransactionGroupModel;
  financialRatio!: ElementExecutiveSummaryTransactionGroupModel;
}

export class ElementExecutiveSummaryRemarkModel {
  no!: number;
  description!: string;
  header!: string;
  isShowElement!: boolean;
}

export class ElementExecutiveSummaryTransactionGroupModel {
  name!: string;
  isShowElement!: boolean;
  transactionList!: Array<ElementExecutiveSummaryTransactionItemModel>;
}

export class ElementExecutiveSummaryTransactionItemModel {
  name!: string;
  type!: ExecutiveSummaryTransactionItemType;
  isShowElement!: boolean;
  remarkNo!: number;
  accountList!: Array<DocumentExecutiveSummaryAccountModel>;
  summaryList!: Array<DocumentExecutiveSummaryValueModel>;
  isRevertStyle!: boolean;
}

export class HeaderExecutiveSummaryTransactionColumnModel {
  transactionName!: ColumnModel;
  remark!: ColumnModel;
  freeSpace!: ColumnModel;
  periodList!: Array<ColumnModel>;
}

export class HeaderExecutiveSummaryRemarkColumnModel {
  remark!: ColumnModel;
}
